import { faker } from "@faker-js/faker";
import type { Meta, StoryObj } from "@storybook/react";

import type { TwoColumnListMockItemProps } from "@/__mocks__/lists";
import { fakeTwoColumnListMockItem } from "@/__mocks__/lists";
import { Text } from "@/ui/core";
import type { TwoColumnListProps } from "@/ui/layout";
import { Box, TwoColumnList } from "@/ui/layout";
import { joinTestIDs } from "@/utils/string.util";

const TestID = {
  Item: joinTestIDs("storybook", "item-text"),
};

const TwoColumnMockValues = faker.helpers.multiple(
  () => fakeTwoColumnListMockItem(),
  { count: faker.number.int({ max: 15, min: 5 }) },
);

const StoryMeta: Meta<TwoColumnListProps<TwoColumnListMockItemProps>> = {
  title: "Layout/Two Column List",
  component: TwoColumnList,
  argTypes: {},
  args: {
    data: TwoColumnMockValues,
    testID: joinTestIDs("storybook", "two-column-list"),
  },
};

type Story = StoryObj<TwoColumnListProps<TwoColumnListMockItemProps>>;

const Primary: Story = {
  ...StoryMeta,
  render: (props) => (
    <TwoColumnList
      {...props}
      emptyListComponent={() => (
        <Text
          testID={joinTestIDs("storybook", "empty-list")}
          variant="bodyMedium"
        >
          No items
        </Text>
      )}
      headerLeftItem={
        <Box width={90}>
          <Text testID={joinTestIDs(TestID.Item, "")}>left</Text>
        </Box>
      }
      headerRightItem={<Text testID={joinTestIDs(TestID.Item, "")}>right</Text>}
      renderLeftItem={({ item }) => (
        <Box width={90}>
          <Text testID={joinTestIDs(TestID.Item, "")}>{item.left}</Text>
        </Box>
      )}
      renderRightItem={({ item }: { item: TwoColumnListMockItemProps }) => (
        <Text testID={joinTestIDs(TestID.Item, "")}>{item.right}</Text>
      )}
    />
  ),
};

export { Primary };
export default StoryMeta;
